export enum EnumSituacaoConcorrente {
  ATIVO = 1,
  INATIVO = 2,
}
